import { atom } from "recoil"

export const unreadContactCountRequestIdState = atom({
  key: "atoms/bottomTab/unreadContactCountRequestIdState",
  default: 0,
})
